import shaka from 'shaka-player';
import Logger from '../../utils/logger';
import { ShakaError } from '../../utils/errors';
import { getErrorMessage } from './player-error-messages';

export default class ErrorhandlingService {
  _player = null;

  constructor(player) {
    this._player = player;
  }

  start() {
    this._player.setErrorHandler(this._onCriticalError);
    Logger.debug('Errorhandling service: started');
  }

  stop() {
    this._player.setErrorHandler(null);
    Logger.debug('Errorhandling service: stopped');
  }

  onAdsError = (e) => {
    Logger.warn('Errorhandling service: got Ads error', e);
    this._player.dispatchEvent('adsError', e, true);
  }

  onChromecastError = (e) => {
    Logger.warn('Errorhandling service: got Chromecast error', e);
    this._player.dispatchEvent('chromecastError', e, true);
  }

  onCriticalError = (e) => {
    if (e instanceof shaka.util.Error) {
      this.onShakaError(new ShakaError(e));
      return;
    }

    Logger.error('Errorhandling service: got critical error', e);
    const code = e.code || e.detail?.code || 0;
    const playerError = {
      code,
      errorMessage: getErrorMessage(code, e),
    };
    this._onError(playerError, e);
  }

  onDRMError = (error) => {
    Logger.error('Errorhandling service: got DRM error', error);
    const code = error.detail.code;
    const playerError = {
      code,
      errorMessage: getErrorMessage(code, error),
    };
    this._onError(playerError, error);
  }

  onShakaError = (error) => {
    const code = error.code;
    switch (code) {
      case 1001: {
        // eslint-disable-next-line max-len
        Logger.error(`Shaka engine encountered HTTP network status ${error.data[1]} at uri ${error.data[0]}: ${error.data[2]}`);
        break;
      }

      case 1002: {
        // eslint-disable-next-line max-len
        Logger.error(`Shaka engine encountered an HTTP network request failed with an error, but not from the server at uri ${error.data[0]}: ${error.data[1]}`);
        break;
      }

      default: {
        break;
      }
    }

    const isRecoverableError = error.severity === 1;
    if (isRecoverableError) {
      Logger.warn('Errorhandling service: got recoverable error from shaka', error);
      return;
    }

    Logger.warn('Errorhandling service: got critical error from shaka', error);

    const playerError = {
      code,
      errorMessage: getErrorMessage(code, error),
    };
    this._onError(playerError, error);
  }

  _onError = (playerError, e) => {
    this._player.model = this._player.model.merge({
      playerError,
    });

    this._player._telemetryService?.reportCriticalError(e);

    this._player.dispatchEvent('error', e, true);

    this._player.unload(false, true);
  }
}
